import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2de4ccd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DialogBody" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_3 = {
  class: "CookiesRow D-Flex",
  style: {"gap":"0.5em","flex-direction":"column"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LanguagesArray, (Company) => {
        return (_openBlock(), _createElementBlock("div", {
          key: Company.ID,
          onClick: ($event: any) => (_ctx.SaveLang(Company)),
          class: "M-Auto P1_25em Shadow2 BG3 Rad2 HoverUp Transition0_25 D-Flex FlexColumn FlexCenter",
          style: {"width":"65%","gap":"0.5em","align-items":"center","justify-content":"center"}
        }, [
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
            class: "Pointer D-Flex",
            style: {"height":"4em","width":"4em"},
            src: _ctx.DefaultImageHandler(Company.LogoURL, 'https://cookiesbis.com/assets/Logo.svg')
          }, null, 8, _hoisted_5),
          _createElementVNode("span", null, _toDisplayString(Company.Name), 1)
        ], 8, _hoisted_4))
      }), 128))
    ]),
    _hoisted_6
  ]))
}